<template>
    <div>

        <Header class="text-center">
            <h2 class="margin-bottom-50">Find the Right Fit for Your Hiring Goals</h2>
            <p>
                At Macher, we connect businesses with top talent in the Jewish community.<br> With our streamlined
                process
                and effective tools, <br>finding the right candidate has never been simpler.
            </p>
            <p>
                Have more questions?
            </p>
            <p>
                <a href="mailto:info@macherusa.com">Email Us</a> or call <a href="tel:845-570-2713">845-570-2713 </a>
            </p>
        </Header>

        <div class="container margin-bottom-100">

            <div class="row">
                <div class="col-xl-12">

                    <!-- Pricing Plans Container -->
                    <div class="pricing-plans-container">
                        <!-- Plan -->
                        <template>
                            <PricingCard v-for="item in PricingDetails" :key="item.id" :item="item">
                            </PricingCard>
                        </template>
                        <!-- <PricingCard v-else class="loading" v-for="item in 3" :key="item">
                        </PricingCard> -->
                    </div>

                </div>

            </div>
        </div>
    </div>
</template>

<script>
import PricingCard from "~/components/pricing/Card.vue";
import Header from '../components/base/Header.vue';
import Heading1 from '../components/base/Heading1.vue';
import ads from '../content/pricing/ads.json';

export default {
    components: {
        PricingCard,
        Header,
        Heading1
    },
    data() {
        return {
            PricingDetails: ads,
            head: {
                title: "Macher Pricing - Advertise on Macher and get seen by 50,000+ visitors!",
                description: "Macher Pricing - Advertise on Macher and get seen by 50,000+ visitors!",
            }
        }
    },
    head() {
        const { path = "" } = this.$route;

        const metaTitle = this.head.title;
        const metaDescription = this.head.description
        const canonical = process.env.baseUrl + path;

        return {
            title: metaTitle,
            link: [{ rel: "canonical", href: canonical }],
            meta: this.createMetaTags({
                description: metaDescription,
                title: metaTitle,
                canonical,
                socialTitle: metaTitle,
                socialDescription: metaDescription,
                siteName: "Macher Jobs",
                twitter: "@FrumJewishJobs",
            }),
        };
    }

}
</script>
<style scoped>
a {
    color: #2a41e8;
}
</style>